module.exports = __webpack_public_path__ + "img/form-settings-prefill.6abb5f6e.svg";